export default function ({ el }) {
    const ACTIVE_CLASS = 'active'
    const panel = el.querySelector('.navigation-panel')
    const toggler = el.querySelector('.navigation-toggler')
    const html = document.getElementsByTagName('html')[0]

    const open = () => {
        panel.classList.add(ACTIVE_CLASS)
        toggler.classList.add(ACTIVE_CLASS)
        window.addEventListener('resize', onResize)
        html.classList.add('menu-open')
    }

    const close = () => {
        panel.classList.remove(ACTIVE_CLASS)
        toggler.classList.remove(ACTIVE_CLASS)
        window.removeEventListener('resize', onResize)
        html.classList.remove('menu-open')
    }

    const onClick = () => {
        if (panel.classList.contains(ACTIVE_CLASS)) {
            close()
        } else {
            open()
        }
    }

    const onResize = () => {
        const mobileNavigationBreakpoint = 1024

        if (window.innerWidth > mobileNavigationBreakpoint) {
            close()
        }
    }

    if (toggler) {
        toggler.addEventListener('click', onClick)
    }
}
